import { useNavigate } from "react-router-dom";

const UseHandleBack = (fallbackPath = "/") => {
	const navigate = useNavigate();

	const handleBack = () => {
		if (window.history.length > 1) {
			navigate(-1);
		} else {
			navigate(fallbackPath);
		}
	};

	return handleBack;
};

export default UseHandleBack;
